import { buildApiUrl, createHeaders } from "./apiClient";
import { getCurrentUserId } from "./authService";

const headers = () => createHeaders({ json: true, userId: getCurrentUserId() });

export async function fetchSurveys({ kind, locale } = {}) {
  const params = new URLSearchParams();
  if (kind) params.set("kind", kind);
  if (locale) params.set("locale", locale);
  const qs = params.toString();
  const res = await fetch(buildApiUrl(`/surveys${qs ? `?${qs}` : ""}`), { headers: headers() });
  if (!res.ok) throw new Error(`fetchSurveys: ${res.status}`);
  return res.json();
}

export async function fetchSurvey(code, locale) {
  const params = locale ? `?locale=${locale}` : "";
  const res = await fetch(buildApiUrl(`/surveys/${code}${params}`), { headers: headers() });
  if (!res.ok) throw new Error(`fetchSurvey: ${res.status}`);
  return res.json();
}

export async function startOrResumeResponse(code, { sourceContext = "dashboard", locale, metadata } = {}) {
  const res = await fetch(buildApiUrl(`/surveys/${code}/responses`), {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ source_context: sourceContext, locale, metadata }),
  });
  if (res.status === 429) throw new Error("rate_limit");
  if (!res.ok) throw new Error(`startOrResumeResponse: ${res.status}`);
  return res.json();
}

export async function saveAnswers(responseId, answers) {
  const res = await fetch(buildApiUrl(`/surveys/responses/${responseId}/answers`), {
    method: "PATCH",
    headers: headers(),
    body: JSON.stringify({ answers }),
  });
  if (res.status === 422) {
    const body = await res.json();
    const err = new Error("validation");
    err.details = body.details;
    throw err;
  }
  if (!res.ok) throw new Error(`saveAnswers: ${res.status}`);
  return res.json();
}

export async function completeResponse(responseId) {
  const res = await fetch(buildApiUrl(`/surveys/responses/${responseId}/complete`), {
    method: "POST",
    headers: headers(),
  });
  if (res.status === 422) {
    const body = await res.json();
    const err = new Error("missing_required");
    err.missingCodes = body.missing_question_codes;
    throw err;
  }
  if (!res.ok) throw new Error(`completeResponse: ${res.status}`);
  return res.json();
}

export async function abandonResponse(responseId) {
  const res = await fetch(buildApiUrl(`/surveys/responses/${responseId}/abandon`), {
    method: "POST",
    headers: headers(),
  });
  if (!res.ok) throw new Error(`abandonResponse: ${res.status}`);
  return res.json();
}

export async function fetchMyStatus(locale) {
  const params = locale ? `?locale=${locale}` : "";
  const res = await fetch(buildApiUrl(`/surveys/me/status${params}`), { headers: headers() });
  if (!res.ok) throw new Error(`fetchMyStatus: ${res.status}`);
  return res.json();
}

export async function fetchResponseStatus(code) {
  const res = await fetch(buildApiUrl(`/surveys/${code}/status`), { headers: headers() });
  if (!res.ok) throw new Error(`fetchResponseStatus: ${res.status}`);
  return res.json();
}

export async function recordConsent({ consentType, granted, consentTextVersion = "1.0", sourceContext = "dashboard" }) {
  const res = await fetch(buildApiUrl("/surveys/consent"), {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({
      consent_type: consentType,
      granted,
      consent_text_version: consentTextVersion,
      source_context: sourceContext,
    }),
  });
  if (!res.ok) throw new Error(`recordConsent: ${res.status}`);
  return res.json();
}

export async function fetchConsent() {
  const res = await fetch(buildApiUrl("/surveys/consent"), { headers: headers() });
  if (!res.ok) throw new Error(`fetchConsent: ${res.status}`);
  return res.json();
}

export async function fetchUnlocks(feature) {
  const params = feature ? `?feature=${feature}` : "";
  const res = await fetch(buildApiUrl(`/surveys/unlocks${params}`), { headers: headers() });
  if (!res.ok) throw new Error(`fetchUnlocks: ${res.status}`);
  return res.json();
}
